import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import styles from "../../../InfoCliniche/InfoCliniche.module.css";
import Calendar from "../../../../../../components/calendar/Calendar";
import RadioButton from "../../../../../../components/radiobutton/RadioButton";
import Input from "../../../../../../components/textbox/Input";
import Utils from "../../../../../../utils/Utils";
import OggettiUtili from "../../../../../../utils/OggettiUtili.json"


class InformazioniCliniche extends Component {

    state = {
        informazioniCliniche: {
            dataPrimiSintomi: "",
            dataRicovero: "",
            nomeOspedale: "",
            reparto: "",
            altroReparto: "",
            tipologiaTerapiaIntensiva: "",
            dataInizioTerapia: "",
            terapiaAntivirale: "",
            presenzaPatologie: "",
            durataGiorni: "",
            tumore: "",
            diabete: "",
            malattieCardiovascolari: "",
            deficitImmunitari: "",
            malattieRespiratorie: "",
            malattieRenali: "",
            malattieMetaboliche: "",
            obesita30: "",
            obesita40: "",
            altroTipoPatologia: "",
            corretto: []
        },
        struttureAndStabilimenti: JSON.parse(sessionStorage.getItem("struttureAndStabilimenti")),
        struttureAndStabilimentiPerCodice: JSON.parse(sessionStorage.getItem("struttureAndStabilimentiPerCodice"))

    }

    constructor(props) {
        super(props);
        this.riceviValoreRadioButton = this.riceviValoreRadioButton.bind(this);
        this.riceviValoreInput = this.riceviValoreInput.bind(this);
        this.controllaDati = this.controllaDati.bind(this);
        this.createJsonForBackend = this.createJsonForBackend.bind(this)
        this.validate = this.validate.bind(this)
    }

    componentDidMount() {
        let informazioniCliniche = this.state.informazioniCliniche

        if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.informazioniCliniche) {
            let propsInfo = JSON.parse(JSON.stringify(this.props.segnalazioneCopia.schedaSpeciale.informazioniCliniche))
            informazioniCliniche.dataPrimiSintomi = propsInfo.dataPrimiSintomi ? propsInfo.dataPrimiSintomi : ""
            informazioniCliniche.nomeOspedale = propsInfo.nomeOspedale && this.state.struttureAndStabilimentiPerCodice && this.state.struttureAndStabilimentiPerCodice[propsInfo.nomeOspedale] ? this.state.struttureAndStabilimentiPerCodice[propsInfo.nomeOspedale].codice : propsInfo.nomeOspedale
            informazioniCliniche.dataRicovero = propsInfo.dataRicovero ? propsInfo.dataRicovero : (this.props.segnalazioneCopia.datiSanitari.dataRicovero ? Utils.formatDateISO(this.props.segnalazioneCopia.datiSanitari.dataRicovero) : "")
            informazioniCliniche.reparto = propsInfo.reparto ? propsInfo.reparto : ""
            informazioniCliniche.altroReparto = propsInfo.altroReparto ? propsInfo.altroReparto : ""
            informazioniCliniche.tipologiaTerapiaIntensiva = propsInfo.tipologiaTerapiaIntensiva ? propsInfo.tipologiaTerapiaIntensiva : ""
            informazioniCliniche.dataInizioTerapia = propsInfo.dataInizioTerapia ? propsInfo.dataInizioTerapia : ""
            informazioniCliniche.terapiaAntivirale = propsInfo.terapiaAntivirale ? propsInfo.terapiaAntivirale : ""
            informazioniCliniche.presenzaPatologie = propsInfo.presenzaPatologie ? propsInfo.presenzaPatologie : ""
            informazioniCliniche.durataGiorni = propsInfo.durataGiorni ? propsInfo.durataGiorni : ""
            informazioniCliniche.tumore = propsInfo.tumore ? propsInfo.tumore : ""
            informazioniCliniche.diabete = propsInfo.diabete ? propsInfo.diabete : ""
            informazioniCliniche.malattieCardiovascolari = propsInfo.malattieCardiovascolari ? propsInfo.malattieCardiovascolari : ""
            informazioniCliniche.deficitImmunitari = propsInfo.deficitImmunitari ? propsInfo.deficitImmunitari : ""
            informazioniCliniche.malattieRespiratorie = propsInfo.malattieRespiratorie ? propsInfo.malattieRespiratorie : ""
            informazioniCliniche.malattieRenali = propsInfo.malattieRenali ? propsInfo.malattieRenali : ""
            informazioniCliniche.malattieMetaboliche = propsInfo.malattieMetaboliche ? propsInfo.malattieMetaboliche : ""
            informazioniCliniche.obesita30 = propsInfo.obesita30 ? propsInfo.obesita30 : ""
            informazioniCliniche.obesita40 = propsInfo.obesita40 ? propsInfo.obesita40 : ""
            informazioniCliniche.altroTipoPatologia = propsInfo.altroTipoPatologia ? propsInfo.altroTipoPatologia : ""

        } else {
            informazioniCliniche.dataPrimiSintomi = this.props.segnalazioneCopia.datiSanitari.dataInizioSintomi ? Utils.formatDateISO(this.props.segnalazioneCopia.datiSanitari.dataInizioSintomi) : ""
            informazioniCliniche.nomeOspedale = this.props.segnalazioneCopia.datiSanitari.struttura ? this.state.struttureAndStabilimentiPerCodice[this.props.segnalazioneCopia.datiSanitari.struttura].descrizione :
                this.props.segnalazioneCopia.datiSanitari.strutturaExtra ? this.state.struttureAndStabilimentiPerCodice[this.props.segnalazioneCopia.datiSanitari.strutturaExtra].descrizione : ""
            informazioniCliniche.dataRicovero = this.props.segnalazioneCopia.datiSanitari.dataRicovero ? Utils.formatDateISO(this.props.segnalazioneCopia.datiSanitari.dataRicovero) : ""
        }
        this.setState({informazioniCliniche: informazioniCliniche});
        this.controllaDati();
        this.props.setInformazioniCliniche(this.state.informazioniCliniche);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        this.controllaDati();

        if (prevState !== this.state) {
            let res = this.createJsonForBackend()
            this.props.setInformazioniCliniche(this.state.informazioniCliniche, this.validate(), res);
        }
    }

    validate() {

        if (this.state.informazioniCliniche.dataInizioTerapia) {
            let validatedataInizioTerapia = Utils.checkDateInterval(this.state.informazioniCliniche.dataInizioTerapia, "31/12/1899");
            let validatedataInizioTerapiaOdierna = Utils.checkDateInterval(this.state.informazioniCliniche.dataInizioTerapia, Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp()));

            if (validatedataInizioTerapia) {
                return "Messages.DataTerapia"
            } else if (!validatedataInizioTerapiaOdierna) {
                return "Messages.DataTerapiaOdierna"
            }
        }
        if (this.state.informazioniCliniche.dataPrimiSintomi) {
            let validatedataPrimiSintomi = Utils.checkDateInterval(this.state.informazioniCliniche.dataPrimiSintomi, "31/12/1899");
            let validatedataPrimiSintomiOdierna = Utils.checkDateInterval(this.state.informazioniCliniche.dataPrimiSintomi, Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp()));

            if (validatedataPrimiSintomi) {
                return "Messages.DataSintomi"
            } else if (!validatedataPrimiSintomiOdierna) {
                return "Messages.DataSintomiOdierna"
            }
        }
        if (this.state.informazioniCliniche.dataRicovero) {
            let validatedataRicovero = Utils.checkDateInterval(this.state.informazioniCliniche.dataRicovero, "31/12/1899");
            let validatedataRicoveroOdierna = Utils.checkDateInterval(this.state.informazioniCliniche.dataRicovero, Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp()));

            if (validatedataRicovero) {
                return "Messages.DataRicovero"
            } else if (!validatedataRicoveroOdierna) {
                return "Messages.DataRicoveroOdierna"
            }
        }

        if (this.state.informazioniCliniche.terapiaAntivirale !== "01") {
            if (this.state.informazioniCliniche.dataInizioTerapia) return "Messages.ERR_01_02_0C_0V"
            if (this.state.informazioniCliniche.durataGiorni) return "Messages.ERR_01_02_0C_0Z"
        }

        return ""

    }


    createJsonForBackend() {
        let dati = this.state.informazioniCliniche
        let ObjectForBackEnd = {}
        ObjectForBackEnd["dataPrimiSintomi"] = dati.dataPrimiSintomi
        ObjectForBackEnd["dataRicovero"] = dati.dataRicovero
        if (dati.nomeOspedale) {
            ObjectForBackEnd["nomeOspedale"] = dati.nomeOspedale
        }
        ObjectForBackEnd["reparto"] = dati.reparto
        ObjectForBackEnd["altroReparto"] = dati.altroReparto
        ObjectForBackEnd["tipologiaTerapiaIntensiva"] = dati.tipologiaTerapiaIntensiva
        ObjectForBackEnd["dataInizioTerapia"] = dati.dataInizioTerapia
        ObjectForBackEnd["terapiaAntivirale"] = dati.terapiaAntivirale
        ObjectForBackEnd["presenzaPatologie"] = dati.presenzaPatologie
        ObjectForBackEnd["durataGiorni"] = dati.durataGiorni
        ObjectForBackEnd["tumore"] = dati.tumore
        ObjectForBackEnd["diabete"] = dati.diabete
        ObjectForBackEnd["malattieCardiovascolari"] = dati.malattieCardiovascolari
        ObjectForBackEnd["deficitImmunitari"] = dati.deficitImmunitari
        ObjectForBackEnd["malattieRespiratorie"] = dati.malattieRespiratorie
        ObjectForBackEnd["malattieRenali"] = dati.malattieRenali
        ObjectForBackEnd["malattieMetaboliche"] = dati.malattieMetaboliche
        ObjectForBackEnd["obesita30"] = dati.obesita30
        ObjectForBackEnd["obesita40"] = dati.obesita40
        ObjectForBackEnd["altroTipoPatologia"] = dati.altroTipoPatologia

        let res = Utils.removeEmptyValueFromObject(ObjectForBackEnd);
        return res;
    }

    controllaDati() {

        let dati = this.state.informazioniCliniche
        dati.corretto = []

        if(!dati.dataPrimiSintomi || (dati.dataPrimiSintomi && Utils.isDateInValid(Utils.transformDateForBackend(dati.dataPrimiSintomi), "-"))) dati.corretto[0] = "Campo \"Data insorgenza primi sintomi\" mancante o errato";
        if(dati.dataRicovero && Utils.isDateInValid(Utils.transformDateForBackend(dati.dataRicovero), "-")) dati.corretto[1] = "Campo \"Data Ricovero\" mancante o errato";
        if(!dati.nomeOspedale) dati.corretto[2] = "Campo \"Nome Ospedale\" mancante ";
        if(!dati.reparto || (dati.reparto === "01" && !dati.tipologiaTerapiaIntensiva)) dati.corretto[3] = "Campo \"Reparto (Specificare)\" mancante";
        if(dati.reparto === "06" && !dati.altroReparto) dati.corretto[4] = "Campo \"Reparto (Specificare) - Altro\" mancante";
        if(dati.presenzaPatologie === "01" && dati.tumore === "02" &&
            dati.diabete === "02" &&
            dati.malattieCardiovascolari === "02" &&
            dati.deficitImmunitari === "02" &&
            dati.malattieRespiratorie === "02" &&
            dati.malattieRenali === "02" &&
            dati.malattieMetaboliche === "02" &&
            dati.obesita30 === "02" &&
            dati.obesita40 === "02" && !dati.altroTipoPatologia) dati.corretto[5] = "Campo \"Se si, quali?\" mancante";
        if(dati.terapiaAntivirale === "01"){
            if(dati.durataGiorni === "") dati.corretto[6] = "Campo \"Durata(giorni)\" mancante";
            if(!dati.dataInizioTerapia || (dati.dataInizioTerapia && Utils.isDateInValid(Utils.transformDateForBackend(dati.dataInizioTerapia), "-"))) dati.corretto[6] = "Campo \"Se si, data inizio terapia\" mancante o errato";
        }
    }

    riceviValoreRadioButton(event, field) {
        let informazioniCliniche = this.state.informazioniCliniche
        informazioniCliniche[field] = event
        if (informazioniCliniche.reparto !== "01") {
            informazioniCliniche.tipologiaTerapiaIntensiva = ""
        }
        if (informazioniCliniche.reparto !== "06") {
            informazioniCliniche.altroReparto = ""
        }

        if (informazioniCliniche.presenzaPatologie !== "01") {
            informazioniCliniche.tumore = ""
            informazioniCliniche.diabete = ""
            informazioniCliniche.malattieCardiovascolari = ""
            informazioniCliniche.deficitImmunitari = ""
            informazioniCliniche.malattieRespiratorie = ""
            informazioniCliniche.malattieRenali = ""
            informazioniCliniche.malattieMetaboliche = ""
            informazioniCliniche.obesita30 = ""
            informazioniCliniche.obesita40 = ""
            informazioniCliniche.altroTipoPatologia = ""
        } else if (informazioniCliniche.presenzaPatologie === "01" &&
            field === "presenzaPatologie") {
            informazioniCliniche.tumore = "02"
            informazioniCliniche.diabete = "02"
            informazioniCliniche.malattieCardiovascolari = "02"
            informazioniCliniche.deficitImmunitari = "02"
            informazioniCliniche.malattieRespiratorie = "02"
            informazioniCliniche.malattieRenali = "02"
            informazioniCliniche.malattieMetaboliche = "02"
            informazioniCliniche.obesita30 = "02"
            informazioniCliniche.obesita40 = "02"
        }

        this.setState({informazioniCliniche: informazioniCliniche})
    }

    riceviValoreInput(field, event) {

        let informazioniCliniche = this.state.informazioniCliniche
        if (field.currentTarget) {
            informazioniCliniche[field.currentTarget.id] = field.currentTarget.value
        } else {
            informazioniCliniche[field] = event.target.value
        }
        this.setState({informazioniCliniche: informazioniCliniche})
    }

    render() {

        const {t} = this.props

        return (<div style={{marginTop: "20px"}}>
            <div>
                <h6>{t("SchedaInfluenzaGrave.informazioniCliniche")}</h6>
                <hr className={styles.hr}/>
            </div>
            <div className={"container"}>
                <div className="row" style={{marginTop: "10px"}}>
                    <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                        <p className={styles.testo}
                           style={{marginTop: "10px"}}>{t("SchedaInfluenzaGrave.dataPrimiSintomi")}<span
                            className={styles.mandatoryColor}>*</span></p>
                        <Calendar id={"dataPrimiSintomi"}
                                  field={"dataPrimiSintomi"}
                                  value={this.state.informazioniCliniche.dataPrimiSintomi}
                                  onChange={this.riceviValoreInput}
                                  errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                      "Data")}
                                  error={(this.state.informazioniCliniche.dataPrimiSintomi === "" ||
                                      this.state.informazioniCliniche.dataPrimiSintomi == null) ? false :
                                      Utils.isDateInValid(Utils.transformDateForBackend(this.state.informazioniCliniche.dataPrimiSintomi), "-")}>
                        </Calendar>
                    </div>
                    <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                        <p className={styles.testo}
                           style={{marginTop: "10px"}}>{t("SchedaInfluenzaGrave.dataRicovero")}</p>
                        <Calendar id={"dataRicovero"}
                                  field={"dataRicovero"}
                                  value={this.state.informazioniCliniche.dataRicovero}
                                  onChange={this.riceviValoreInput}
                                  errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                      "Data")}
                                  error={(this.state.informazioniCliniche.dataRicovero === "" ||
                                      this.state.informazioniCliniche.dataRicovero == null) ? false :
                                      Utils.isDateInValid(Utils.transformDateForBackend(this.state.informazioniCliniche.dataRicovero), "-")}>
                        </Calendar>
                    </div>
                    <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                        <div className={styles.fieldContainer}>

                            <p className={styles.testo}
                               style={{marginTop: "10px"}}>{t("SchedaInfluenzaGrave.nomeOspedale")}<span
                                className={styles.mandatoryColor}>*</span></p>
                            <Input id={"nomeOspedale"}
                                onChange={this.riceviValoreInput}
                                field={"nomeOspedale"}
                                value={this.state.informazioniCliniche.nomeOspedale}
                                placeholder={t("SchedaInfluenzaGrave.nomeOspedale")}
                            />
                        </div>
                    </div>

                </div>
                <div className="row" style={{marginTop: "10px"}}>
                    <div className="col-lg-3">
                        <p style={{marginTop: "10px"}}><b>{t("SchedaInfluenzaGrave.reparto")}</b><span
                            className={styles.mandatoryColor}>*</span></p>

                    </div>
                    <div className="col-lg-7">
                        <div className="row">
                            <div className="col-lg-7">
                                <RadioButton id={"reparto01"}
                                    name={"reparto"}
                                    label={t("SchedaInfluenzaGrave.terapiaIntensiva").concat(":")}
                                    value={"01"} onClick={() => this.riceviValoreRadioButton("01", "reparto")}
                                    checked={this.state.informazioniCliniche.reparto === "01"}
                                    required={this.state.informazioniCliniche.reparto === "01"}
                                />
                            </div>
                            <div className="col-lg-2">
                                <RadioButton id={"intubato"}
                                    name={"tipologiaTerapiaIntensiva"}
                                    label={t("SchedaInfluenzaGrave.intubato")}
                                    value={"01"} disabled={this.state.informazioniCliniche.reparto !== "01"}
                                    onClick={() => this.riceviValoreRadioButton("01", "tipologiaTerapiaIntensiva")}
                                    checked={this.state.informazioniCliniche.tipologiaTerapiaIntensiva === "01"}
                                />
                            </div>
                            <div className="col-lg-2">
                                <RadioButton id={"ecmo"}
                                    name={"tipologiaTerapiaIntensiva"} label={t("SchedaInfluenzaGrave.ecmo")}
                                    value={"02"} disabled={this.state.informazioniCliniche.reparto !== "01"}
                                    onClick={() => this.riceviValoreRadioButton("02", "tipologiaTerapiaIntensiva")}
                                    checked={this.state.informazioniCliniche.tipologiaTerapiaIntensiva === "02"}
                                />
                            </div>
                        </div>
                        <RadioButton id={"reparto02"}
                            name={"reparto"} label={t("SchedaInfluenzaGrave.dea")}
                            value={"02"} onClick={() => this.riceviValoreRadioButton("02", "reparto")}
                            checked={this.state.informazioniCliniche.reparto === "02"}
                        />
                        <RadioButton id={"reparto03"}
                            name={"reparto"} label={t("SchedaInfluenzaGrave.terapiaSubIntensiva")}
                            value={"03"} onClick={() => this.riceviValoreRadioButton("03", "reparto")}
                            checked={this.state.informazioniCliniche.reparto === "03"}
                        />
                        <RadioButton id={"reparto04"}
                            name={"reparto"} label={t("SchedaInfluenzaGrave.cardioChirurgia")}
                            value={"04"} onClick={() => this.riceviValoreRadioButton("04", "reparto")}
                            checked={this.state.informazioniCliniche.reparto === "04"}
                        />
                        <RadioButton id={"reparto05"}
                            name={"reparto"} label={t("SchedaInfluenzaGrave.malattieInfettive")}
                            value={"05"} onClick={() => this.riceviValoreRadioButton("05", "reparto")}
                            checked={this.state.informazioniCliniche.reparto === "05"}
                        />
                        <div className="row">
                            <div className="col-lg-4">
                                <RadioButton id={"reparto06"}
                                    name={"reparto"} label={t("SchedaInfluenzaGrave.altro")}
                                    value={"06"} onClick={() => this.riceviValoreRadioButton("06", "reparto")}
                                    checked={this.state.informazioniCliniche.reparto === "06"}
                                />
                            </div>
                            <div className="col-lg-5">
                                <Input id={"altroReparto"}
                                       field={"altroReparto"}
                                       value={this.state.informazioniCliniche.altroReparto}
                                       disabled={this.state.informazioniCliniche.reparto !== "06"}
                                       placeholder={"Altro"}
                                       required={this.state.informazioniCliniche.reparto === "06"}
                                       onChange={this.riceviValoreInput}
                                >
                                </Input>
                            </div>
                        </div>
                    </div>


                </div>
                <div className="row" style={{marginTop: "10px"}}>
                    <div className="col-lg-6">
                        <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                            <b>{t("SchedaInfluenzaGrave.terapiaAntivirale")}</b></p>

                    </div>
                    <div className="col-lg-6">
                        <div className="row">
                            <RadioButton id={"sterapiaAntiviraleSi"}
                                name={"terapiaAntivirale"} label={t("SchedaInfluenzaGrave.si")}
                                value={"01"}
                                onClick={() => this.riceviValoreRadioButton("01", "terapiaAntivirale")}
                                checked={this.state.informazioniCliniche.terapiaAntivirale === "01"}
                            />
                            <RadioButton id={"terapiaAntiviraleNo"}
                                name={"terapiaAntivirale"} label={t("SchedaInfluenzaGrave.no")}
                                value={"02"}
                                onClick={() => this.riceviValoreRadioButton("02", "terapiaAntivirale")}
                                checked={this.state.informazioniCliniche.terapiaAntivirale === "02"}
                            />
                        </div>
                    </div>
                </div>
                <div className="row" style={{marginTop: "10px"}}>
                    <div className="col-lg-6">
                        <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                            <b>{t("SchedaInfluenzaGrave.dataInizioTerapia")}{this.state.informazioniCliniche.terapiaAntivirale === "01" ?
                                <span className={styles.mandatoryColor}>*</span> : ""}</b></p>

                    </div>
                    <div className="col-lg-3">
                        <Calendar id={"dataInizioTerapia"}
                                  field={"dataInizioTerapia"}
                                  value={this.state.informazioniCliniche.dataInizioTerapia}
                                  onChange={this.riceviValoreInput}
                                  errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                      "Data")}
                                  error={(this.state.informazioniCliniche.dataInizioTerapia === "" ||
                                      this.state.informazioniCliniche.dataInizioTerapia == null) ? false :
                                      Utils.isDateInValid(Utils.transformDateForBackend(this.state.informazioniCliniche.dataInizioTerapia), "-")}>

                        </Calendar>
                    </div>
                </div>
                <div className="row" style={{marginTop: "10px"}}>

                    <div className="col-lg-6">
                        <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                            <b>{t("SchedaInfluenzaGrave.durata")} {this.state.informazioniCliniche.terapiaAntivirale === "01" ?
                                <span className={styles.mandatoryColor}>*</span> : ""}</b></p>

                    </div>
                    <div className="col-lg-1">
                        <Input id={"durataGiorni"}
                               field={"durataGiorni"}
                               value={this.state.informazioniCliniche.durataGiorni}
                               placeholder={"Durata"}
                               onChange={this.riceviValoreInput}
                               type={"number"}
                               min={"0"}
                        >
                        </Input>
                    </div>
                </div>
                <div className="row" style={{marginTop: "10px"}}>
                    <div className="col-lg-6">
                        <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                            <b>{t("SchedaInfluenzaGrave.presenzaPatologie")}</b><span
                            className={styles.mandatoryColor}>*</span></p>

                    </div>
                    <div className="col-lg-6">
                        <div className="row">
                            <RadioButton id={"presenzaPatologieSi"}
                                name={"presenzaPatologie"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                value={"01"}
                                onClick={() => this.riceviValoreRadioButton("01", "presenzaPatologie")}
                                checked={this.state.informazioniCliniche.presenzaPatologie === "01"}
                            >
                            </RadioButton>
                            <RadioButton id={"presenzaPatologieNo"}
                                name={"presenzaPatologie"} label={t("SchedaEpatite.risposteTipoUno.no")}
                                value={"02"}
                                onClick={() => this.riceviValoreRadioButton("02", "presenzaPatologie")}
                                checked={this.state.informazioniCliniche.presenzaPatologie === "02"}
                            />
                            <RadioButton id={"presenzaPatologieNonSo"}
                                name={"presenzaPatologie"} label={t("SchedaEpatite.risposteTipoUno.nonso")}
                                value={"03"}
                                onClick={() => this.riceviValoreRadioButton("03", "presenzaPatologie")}
                                checked={this.state.informazioniCliniche.presenzaPatologie === "03"}
                            />
                        </div>
                    </div>
                </div>
                <div className="row" style={{marginTop: "10px"}}>
                    <div className="col-lg-6">
                        <p className={styles.labelHeader}
                           style={{marginTop: "10px"}}>{t("SchedaInfluenzaGrave.quali")}</p>

                    </div>

                </div>
                <div className="row">
                    <div className="col-lg-6"><p className={styles.labelHeader} style={{marginTop: "10px"}}>
                        <b>{t("SchedaInfluenzaGrave.tumore")}</b></p></div>
                    <div className="col-lg-6">
                        <div className="row">
                            <RadioButton id={"tumoreSi"}
                                name={"tumore"} label={t("SchedaInfluenzaGrave.si")}
                                value={"01"}
                                onClick={() => this.riceviValoreRadioButton("01", "tumore")}
                                disabled={this.state.informazioniCliniche.presenzaPatologie !== "01"}
                                checked={this.state.informazioniCliniche.tumore === "01"}
                            />
                            <RadioButton id={"tumoreNo"}
                                name={"tumore"} label={t("SchedaInfluenzaGrave.no")}
                                value={"02"}
                                onClick={() => this.riceviValoreRadioButton("02", "tumore")}
                                disabled={this.state.informazioniCliniche.presenzaPatologie !== "01"}
                                checked={this.state.informazioniCliniche.tumore === "02"}
                            />
                            <RadioButton id={"tumoreNonSo"}
                                name={"tumore"} label={t("SchedaInfluenzaGrave.nonNoto")}
                                value={"03"}
                                onClick={() => this.riceviValoreRadioButton("03", "tumore")}
                                disabled={this.state.informazioniCliniche.presenzaPatologie !== "01"}
                                checked={this.state.informazioniCliniche.tumore === "03"}
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-6"><p className={styles.labelHeader} style={{marginTop: "10px"}}>
                        <b>{t("SchedaInfluenzaGrave.diabete")}</b></p></div>
                    <div className="col-lg-6">
                        <div className="row">
                            <RadioButton id={"diabeteSi"}
                                 name={"diabete"} label={t("SchedaInfluenzaGrave.si")}
                                value={"01"}
                                onClick={() => this.riceviValoreRadioButton("01", "diabete")}
                                disabled={this.state.informazioniCliniche.presenzaPatologie !== "01"}
                                checked={this.state.informazioniCliniche.diabete === "01"}
                            />
                            <RadioButton id={"diabeteNo"}
                                name={"diabete"} label={t("SchedaInfluenzaGrave.no")}
                                value={"02"}
                                disabled={this.state.informazioniCliniche.presenzaPatologie !== "01"}
                                onClick={() => this.riceviValoreRadioButton("02", "diabete")}
                                checked={this.state.informazioniCliniche.diabete === "02"}
                            />
                            <RadioButton id={"diabeteNonSo"}
                                name={"diabete"} label={t("SchedaInfluenzaGrave.nonNoto")}
                                value={"03"}
                                disabled={this.state.informazioniCliniche.presenzaPatologie !== "01"}
                                onClick={() => this.riceviValoreRadioButton("03", "diabete")}
                                checked={this.state.informazioniCliniche.diabete === "03"}
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-6"><p className={styles.labelHeader} style={{marginTop: "10px"}}>
                        <b>{t("SchedaInfluenzaGrave.malattieCardiovascolari")}</b></p></div>
                    <div className="col-lg-6">
                        <div className="row">
                            <RadioButton id={"malattieCardiovascolariSi"}
                                name={"malattieCardiovascolari"} label={t("SchedaInfluenzaGrave.si")}
                                value={"01"}
                                disabled={this.state.informazioniCliniche.presenzaPatologie !== "01"}
                                onClick={() => this.riceviValoreRadioButton("01", "malattieCardiovascolari")}
                                checked={this.state.informazioniCliniche.malattieCardiovascolari === "01"}
                            />
                            <RadioButton id={"malattieCardiovascolariNo"}
                                name={"malattieCardiovascolari"} label={t("SchedaInfluenzaGrave.no")}
                                value={"02"}
                                disabled={this.state.informazioniCliniche.presenzaPatologie !== "01"}
                                onClick={() => this.riceviValoreRadioButton("02", "malattieCardiovascolari")}
                                checked={this.state.informazioniCliniche.malattieCardiovascolari === "02"}
                            />
                            <RadioButton id={"malattieCardiovascolariNonSo"}
                                name={"malattieCardiovascolari"} label={t("SchedaInfluenzaGrave.nonNoto")}
                                value={"03"}
                                disabled={this.state.informazioniCliniche.presenzaPatologie !== "01"}
                                onClick={() => this.riceviValoreRadioButton("03", "malattieCardiovascolari")}
                                checked={this.state.informazioniCliniche.malattieCardiovascolari === "03"}
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-6"><p className={styles.labelHeader} style={{marginTop: "10px"}}>
                        <b>{t("SchedaInfluenzaGrave.deficitImmunitari")}</b></p></div>
                    <div className="col-lg-6">
                        <div className="row">
                            <RadioButton id={"deficitImmunitariSi"}
                                name={"deficitImmunitari"} label={t("SchedaInfluenzaGrave.si")}
                                value={"01"}
                                disabled={this.state.informazioniCliniche.presenzaPatologie !== "01"}
                                onClick={() => this.riceviValoreRadioButton("01", "deficitImmunitari")}
                                checked={this.state.informazioniCliniche.deficitImmunitari === "01"}
                            />
                            <RadioButton id={"deficitImmunitariNo"}
                                name={"deficitImmunitari"} label={t("SchedaInfluenzaGrave.no")}
                                value={"02"}
                                disabled={this.state.informazioniCliniche.presenzaPatologie !== "01"}
                                onClick={() => this.riceviValoreRadioButton("02", "deficitImmunitari")}
                                checked={this.state.informazioniCliniche.deficitImmunitari === "02"}
                            />
                            <RadioButton id={"deficitImmunitariNonSo"}
                                name={"deficitImmunitari"} label={t("SchedaInfluenzaGrave.nonNoto")}
                                value={"03"}
                                disabled={this.state.informazioniCliniche.presenzaPatologie !== "01"}
                                onClick={() => this.riceviValoreRadioButton("03", "deficitImmunitari")}
                                checked={this.state.informazioniCliniche.deficitImmunitari === "03"}
                            />
                        </div>
                    </div>
                </div>
                <div className="row" style={{marginTop: "10px"}}>
                    <div className="col-lg-6"><p className={styles.labelHeader} style={{marginTop: "10px"}}>
                        <b>{t("SchedaInfluenzaGrave.malattieRespiratorie")}</b></p></div>
                    <div className="col-lg-6">
                        <div className="row">
                            <RadioButton id={"malattieRespiratorieSi"}
                                name={"malattieRespiratorie"} label={t("SchedaInfluenzaGrave.si")}
                                value={"01"}
                                disabled={this.state.informazioniCliniche.presenzaPatologie !== "01"}
                                onClick={() => this.riceviValoreRadioButton("01", "malattieRespiratorie")}
                                checked={this.state.informazioniCliniche.malattieRespiratorie === "01"}
                            />
                            <RadioButton id={"malattieRespiratorieNo"}
                                name={"malattieRespiratorie"} label={t("SchedaInfluenzaGrave.no")}
                                value={"02"}
                                disabled={this.state.informazioniCliniche.presenzaPatologie !== "01"}
                                onClick={() => this.riceviValoreRadioButton("02", "malattieRespiratorie")}
                                checked={this.state.informazioniCliniche.malattieRespiratorie === "02"}
                            />
                            <RadioButton id={"malattieRespiratorieNonSo"}
                                name={"malattieRespiratorie"} label={t("SchedaInfluenzaGrave.nonNoto")}
                                value={"03"}
                                disabled={this.state.informazioniCliniche.presenzaPatologie !== "01"}
                                onClick={() => this.riceviValoreRadioButton("03", "malattieRespiratorie")}
                                checked={this.state.informazioniCliniche.malattieRespiratorie === "03"}
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-6"><p className={styles.labelHeader} style={{marginTop: "10px"}}>
                        <b>{t("SchedaInfluenzaGrave.malattieRenali")}</b></p></div>
                    <div className="col-lg-6">
                        <div className="row">
                            <RadioButton id={"malattieRenaliSi"}
                                name={"malattieRenali"} label={t("SchedaInfluenzaGrave.si")}
                                value={"01"}
                                disabled={this.state.informazioniCliniche.presenzaPatologie !== "01"}
                                onClick={() => this.riceviValoreRadioButton("01", "malattieRenali")}
                                checked={this.state.informazioniCliniche.malattieRenali === "01"}
                            />
                            <RadioButton id={"malattieRenaliNo"}
                                name={"malattieRenali"} label={t("SchedaInfluenzaGrave.no")}
                                value={"02"}
                                disabled={this.state.informazioniCliniche.presenzaPatologie !== "01"}
                                onClick={() => this.riceviValoreRadioButton("02", "malattieRenali")}
                                checked={this.state.informazioniCliniche.malattieRenali === "02"}
                            />
                            <RadioButton id={"malattieRenaliNonSo"}
                                name={"malattieRenali"} label={t("SchedaInfluenzaGrave.nonNoto")}
                                value={"03"}
                                disabled={this.state.informazioniCliniche.presenzaPatologie !== "01"}
                                onClick={() => this.riceviValoreRadioButton("03", "malattieRenali")}
                                checked={this.state.informazioniCliniche.malattieRenali === "03"}
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-6"><p className={styles.labelHeader} style={{marginTop: "10px"}}>
                        <b>{t("SchedaInfluenzaGrave.malattieMetaboliche")}</b></p></div>
                    <div className="col-lg-6">
                        <div className="row">
                            <RadioButton id={"malattieMetabolicheSi"}
                                name={"malattieMetaboliche"} label={t("SchedaInfluenzaGrave.si")}
                                value={"01"}
                                disabled={this.state.informazioniCliniche.presenzaPatologie !== "01"}
                                onClick={() => this.riceviValoreRadioButton("01", "malattieMetaboliche")}
                                checked={this.state.informazioniCliniche.malattieMetaboliche === "01"}
                            />
                            <RadioButton id={"malattieMetabolicheNo"}
                                name={"malattieMetaboliche"} label={t("SchedaInfluenzaGrave.no")}
                                value={"02"}
                                disabled={this.state.informazioniCliniche.presenzaPatologie !== "01"}
                                onClick={() => this.riceviValoreRadioButton("02", "malattieMetaboliche")}
                                checked={this.state.informazioniCliniche.malattieMetaboliche === "02"}
                            />
                            <RadioButton id={"malattieMetabolicheNonSo"}
                                name={"malattieMetaboliche"} label={t("SchedaInfluenzaGrave.nonNoto")}
                                value={"03"}
                                disabled={this.state.informazioniCliniche.presenzaPatologie !== "01"}
                                onClick={() => this.riceviValoreRadioButton("03", "malattieMetaboliche")}
                                checked={this.state.informazioniCliniche.malattieMetaboliche === "03"}
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-6">
                        <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                            <b>{t("SchedaInfluenzaGrave.obesita30")}</b></p></div>
                    <div className="col-lg-6">
                        <div className="row">
                            <RadioButton id={"obesita30Si"}
                                name={"obesita30"} label={t("SchedaInfluenzaGrave.si")}
                                value={"01"}
                                disabled={this.state.informazioniCliniche.presenzaPatologie !== "01"}
                                onClick={() => this.riceviValoreRadioButton("01", "obesita30")}
                                checked={this.state.informazioniCliniche.obesita30 === "01"}
                            />
                            <RadioButton id={"obesita30No"}
                                name={"obesita30"} label={t("SchedaInfluenzaGrave.no")}
                                value={"02"}
                                disabled={this.state.informazioniCliniche.presenzaPatologie !== "01"}
                                onClick={() => this.riceviValoreRadioButton("02", "obesita30")}
                                checked={this.state.informazioniCliniche.obesita30 === "02"}
                            />
                            <RadioButton id={"obesita30NonSo"}
                                name={"obesita30"} label={t("SchedaInfluenzaGrave.nonNoto")}
                                value={"03"}
                                disabled={this.state.informazioniCliniche.presenzaPatologie !== "01"}
                                onClick={() => this.riceviValoreRadioButton("03", "obesita30")}
                                checked={this.state.informazioniCliniche.obesita30 === "03"}
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-6"><p className={styles.labelHeader} style={{marginTop: "10px"}}>
                        <b>{t("SchedaInfluenzaGrave.obesita40")}</b></p></div>
                    <div className="col-lg-6">
                        <div className="row">
                            <RadioButton id={"obesita40Si"}
                                name={"obesita40"} label={t("SchedaInfluenzaGrave.si")}
                                value={"01"}
                                disabled={this.state.informazioniCliniche.presenzaPatologie !== "01"}
                                onClick={() => this.riceviValoreRadioButton("01", "obesita40")}
                                checked={this.state.informazioniCliniche.obesita40 === "01"}
                            />
                            <RadioButton id={"obesita40aNo"}
                                name={"obesita40"} label={t("SchedaInfluenzaGrave.no")}
                                value={"02"}
                                disabled={this.state.informazioniCliniche.presenzaPatologie !== "01"}
                                onClick={() => this.riceviValoreRadioButton("02", "obesita40")}
                                checked={this.state.informazioniCliniche.obesita40 === "02"}
                            />
                            <RadioButton id={"obesita40NonSo"}
                                name={"obesita40"} label={t("SchedaInfluenzaGrave.nonNoto")}
                                value={"03"}
                                disabled={this.state.informazioniCliniche.presenzaPatologie !== "01"}
                                onClick={() => this.riceviValoreRadioButton("03", "obesita40")}
                                checked={this.state.informazioniCliniche.obesita40 === "03"}
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-6">
                        <div className="row">
                            <div className="col-lg-2">
                                <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                    <b>{t("SchedaInfluenzaGrave.altro")}:
                                        {this.state.informazioniCliniche.presenzaPatologie === "01" && this.state.informazioniCliniche.tumore !== "01" && this.state.informazioniCliniche.diabete !== "01" &&
                                        this.state.informazioniCliniche.malattieCardiovascolari !== "01" && this.state.informazioniCliniche.deficitImmunitari !== "01" &&
                                        this.state.informazioniCliniche.malattieRespiratorie !== "01" && this.state.informazioniCliniche.malattieRenali !== "01" &&
                                        this.state.informazioniCliniche.malattieMetaboliche !== "01" && this.state.informazioniCliniche.obesita30 !== "01" &&
                                        this.state.informazioniCliniche.obesita40 !== "01" ?
                                            <span className={styles.mandatoryColor}>*</span> : ""} </b></p>
                            </div>
                            <div className="col-lg-6">
                                <Input id={"altroTipoPatologia"}
                                       field={"altroTipoPatologia"}
                                       value={this.state.informazioniCliniche.altroTipoPatologia}
                                       disabled={this.state.informazioniCliniche.presenzaPatologie !== "01"}
                                       placeholder={"Altro"}
                                       onChange={this.riceviValoreInput}>
                                </Input>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>)
    }


}


export default withTranslation('common')(InformazioniCliniche)
